class BESSAppProjectsSection extends BESSAppBase {
    constructor() {
        super();
        this.present = $('.app-projects-page').length > 0;
        if (!this.present) return;
        this.loadingNextPage = false;
        this.projectsLoadNode = $('.app-projects-contents-load');
    }

    start() {
        if (!this.present) return;
        BESSApp.instance.requireGoogleMaps(this.#mapsReady.bind(this))
    }

    #mapsReady() {
        this.#loadParams();
        this.loader = new BESSDynamicLoader(this.projectsLoadNode, this.#projectsLoaded.bind(this), this.params);
    }

    #loadParams() {
        this.params = {
            'keywords': unescape($.urlParam('keywords', '')),
            'site_type': $.urlParam('site_type', ''),
            'council': $.urlParam('council', ''),
            'engine': $.urlParam('engine', ''),
            'selected_score_band': $.urlParam('selected_score_band', ''),
            'sort_option': $.urlParam('sort_option', ''),
        }


    }

    #projectsLoaded() {
        if ($('.app-projects-empty').length > 0) {
            return;
        }

        this.projectsHeader = new BESSAppProjectsHeader(this);
        this.projectsList = new BESSAppProjectsList(this);

        this.projectsHeader.searchInput.val(unescape(this.params['keywords']));
        this.projectsHeader.selectOption(this.projectsHeader.siteTypesSelect, this.params['site_type'] ? this.params['site_type'] : '0');
        this.projectsHeader.selectOption(this.projectsHeader.councilSelect, this.params['council'] ? this.params['council'] : '0');
        this.projectsHeader.selectOption(this.projectsHeader.engineSelect, this.params['engine'] ? this.params['engine'] : '0');
        this.projectsHeader.selectOption(this.projectsHeader.scoreSelect, this.params['selected_score_band'] ? this.params['selected_score_band'] : '0');
        this.projectsHeader.selectOption(this.projectsHeader.sortSelect, this.params['sort_option'] ? this.params['sort_option'] : '0');

        if ($('#projectCouncil').length > 0) {
            this.councilStatsModal = new BESSAppModal('projectCouncil');
        }
        $('.project-council-list').bindClickEvent(this, this.#onOpenCouncilStats);

        if ($('#projectsMap').length > 0) {
            this.locationsModal = new BESSAppModal('projectsMap');
        }
        $('.projects-map-card').bindClickEvent(this, this.#onOpenProjectsMap);

        new BESSAppProjectsTimeChart();
    }

    reloadProjects() {
        let params = {
            'keywords': this.projectsHeader.searchInput.val(),
            'site_type': this.projectsHeader.siteTypesSelect.val(),
            'council': this.projectsHeader.councilSelect.val(),
            'engine': this.projectsHeader.engineSelect.val(),
            'selected_score_band': this.projectsHeader.scoreSelect.val(),
            'sort_option': this.projectsHeader.sortSelect.val(),
            'stats': false,
            'filter': true,
        }

        if (_.isEqual(params, this.params)) {
            return;
        }
        this.params = params;

        let url = new URL(window.location.href);
        url.searchParams.set("keywords", params['keywords']);
        url.searchParams.set("site_type", params['site_type']);
        url.searchParams.set("council", params['council']);
        url.searchParams.set("engine", params['engine']);
        url.searchParams.set("selected_score_band", params['selected_score_band']);
        url.searchParams.set("sort_option", params['sort_option']);
        window.history.pushState({}, null, url);

        this.loader.reload(params, function (contents) {
            let projectsList = contents.find('.projects-list');
            this.projectsList.reload(projectsList);
            this.projectsHeader.updateProjectsCount(contents.find('.app-projects-count'));

        }.bind(this));
    }

    loadNextPage(fromOffset) {
        if (this.loadingNextPage) {
            return;
        }
        this.loadingNextPage = true;
        this.log('#loadNextPage', fromOffset);
        let params = Object.assign({'offset': fromOffset}, this.params);
        this.loader.reload(params, function (contents) {
            let projectsList = contents.find('.projects-list');
            this.projectsList.append(projectsList);
            this.loadingNextPage = false;
        }.bind(this));
    }

    #onOpenCouncilStats() {
        this.councilStatsModal.open();
    }

    #onOpenProjectsMap() {
        this.locationsModal.open();
    }
}

